// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"98":"262f3eaf","411":"5429c2e0","594":"e773dba9","598":"262f3eaf","624":"7e79d28b","704":"af0ac1e2","795":"af62d2dc"}[chunkId] + ".chunk.css";
};